var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.schemeIcon,"alt":"scheme icon","height":_vm.height,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }